import { TransProp } from '@icc/shared/helpers';
import { RollerGuideChannelCap } from './guide-channel-cap';

export class RollerGuideChannel {
    @TransProp()
    rollerChannel?: RollerGuideChannelCap | null;
    @TransProp()
    mosquitoChannel?: RollerGuideChannelCap | null;
}

class RollerGuideChannels {
    @TransProp()
    left: RollerGuideChannel | null;
    @TransProp()
    right: RollerGuideChannel | null;
}


/** Prowadzenia */
export class RollerGuidesChannelCaps {
    id: number;
    /** Id żaluzji */
    shutterId: number;
    /** Lewe prowadzenie.
     */
    @TransProp()
    left: RollerGuideChannels;
    /**
     * Prawe prowadzenie
     */
    @TransProp()
    right: RollerGuideChannels;

    /** Prowadzenia podziałowe moskitier */
    mosquitoScreens: {
        channels: RollerGuideChannels;
        leftMosquitoScreenId: number | null;
        rightMosquitoScreenId: number | null;
    }[];
}
